// libs/extensions/src/lib/plugins/jmkw-plugins.module.ts

import { CommonModule } from '@angular/common';
import { ToolkitApiService } from '@jeppesen-foreflight/jmkw-toolkit';
import { TwcPluginModule } from './the-weather-company/twc-plugin.module';
import {
  TwcPluginEnvironment,
  TWC_CONFIG_TOKEN
} from './the-weather-company/plugins/twc-config.token';
import { AviationPluginModule } from './jeppesen/aviation/aviation.plugin.module';
import { AVIATION_CONFIG_TOKEN } from './jeppesen/aviation/aviation.config';
import { ObstaclesPluginService } from './jeppesen/aviation/plugins/obstacles/obstacles.plugin.service';
import { TerrainPluginModule } from './jeppesen/terrain/terrain.plugin.module';
import { JmkwAviationConfig } from './jeppesen/types/jeppesen.environment';
import { NgModule, ModuleWithProviders } from '@angular/core';

export { TwcPluginModule } from './the-weather-company/twc-plugin.module';
export { AviationPluginModule } from './jeppesen/aviation/aviation.plugin.module';
export { TerrainPluginModule } from './jeppesen/terrain/terrain.plugin.module';

// Fallback values
const DEFAULT_TWC_CONFIG: TwcPluginEnvironment = {
  apiKey: '4ad9c80ae23f4a0299c80ae23f1a021d'
};

// Fallback values
const DEFAULT_AVIATION_CONFIG: Partial<JmkwAviationConfig> = {
  persona: 'InFlight'
};

export type JmkwPluginEnvironments = {
  aviationPluginEnvironment: JmkwAviationConfig;
  twcPluginEnvironment: TwcPluginEnvironment;
};

@NgModule({
  imports: [
    CommonModule,
    TwcPluginModule,
    AviationPluginModule,
    TerrainPluginModule
  ],
  providers: [
    ObstaclesPluginService,
    ToolkitApiService,
    // Provide default configurations
    {
      provide: TWC_CONFIG_TOKEN,
      useValue: DEFAULT_TWC_CONFIG
    },
    {
      provide: AVIATION_CONFIG_TOKEN,
      useValue: DEFAULT_AVIATION_CONFIG
    }
  ],
  exports: [TwcPluginModule, AviationPluginModule, TerrainPluginModule]
})
export class JmkwPluginModule {
  static forRoot(
    jmkwPluginEnvironments: Partial<JmkwPluginEnvironments> = {}
  ): ModuleWithProviders<JmkwPluginModule> {
    return {
      ngModule: JmkwPluginModule,
      providers: [
        {
          provide: AVIATION_CONFIG_TOKEN,
          useValue:
            jmkwPluginEnvironments.aviationPluginEnvironment ||
            DEFAULT_AVIATION_CONFIG
        },
        {
          provide: TWC_CONFIG_TOKEN,
          useValue:
            jmkwPluginEnvironments.twcPluginEnvironment || DEFAULT_TWC_CONFIG
        }
      ]
    };
  }
}
